function fileAppendToForm(formData, file) {
	if (file.type === 'local') {
		formData.append('file', file.file[0], file.name)
	} else {
		formData.append('file', JSON.stringify(file))
	}
	return formData
}

export default fileAppendToForm
